export class CourseStatusConstants{
    public static readonly Status_Active : number = 0;
    public static readonly StatusName_Active: string = 'Active';
    public static readonly StatusClassName_Active: string = 'active';
    public static readonly Status_Inactive : number = 1;
    public static readonly StatusName_Inactive: string = 'Inactive';
    public static readonly StatusClassName_Inactive: string = 'inactive';
}
